<template>
  <!-- 按地区找律师 -->
  <div class="city">
    <div class="domesticity">
      <!-- <div class="domestitle title24 FontW600">国内城市</div> -->
      <!-- <div class="domesearch flex_start">
        <div class="seaico">
          <img src="../../assets/findlawchild/citysearchicon.png" alt="" />
        </div>
        <input
          type="text"
          v-model="searchvalue"
          class="seatext"
          placeholder="搜索城市"
        />
        <div class="searchbtn">搜索</div>
      </div> -->
    </div>
    <div class="hotcity mt40 flex_start">
      <div class="title24 htit FontW600">热门城市</div>
      <div>
        <span v-for="item in hotcitys" :key="item">{{item.name}}</span>
      </div>
    </div>

    <div class="selecity mt40 flex_start">
      <div class="labelcity FontW600">城市选择</div>
      <div class="select">
        <el-select v-model="provvalue" @change='provchange' placeholder="省份" class="selc">
          <el-option
            v-for="(item,index) in provincecity"
            :key="item.id"
            :label="item.name"
            :value="index"
          >
          </el-option>
        </el-select>
        <el-select v-model="cityvalue"  @change='citychange' placeholder="城市" class="selc">
          <el-option
            v-for="item in provincecity[theindex].children"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="initselect mt40">
      <div class="inititle FontW600">按照省份首字母选择</div>
      <div class="allist">
        <div
          class="sitem flex_start"
          v-for="(allitem, allindex) in citylist"
          :key="allindex"
        >
          <div class="slabel center">
            {{ allindex }}
            <i class="el-icon-caret-right labeicon"></i>
          </div>
          <div class="provincelist" >
            <div
              class="provinceitem "
              v-for="(proitem, proindex) in citylist[allindex]"
              :key="proindex"
			  @click="tolaywer(proitem.id)"
            >
              <!-- <div class="provincetitle">{{ proitem.name }}</div> -->
                  {{ proitem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return{
		searchvalue:'',
		provvalue:0,
		cityvalue:'北京',
		citylist:[],
		hotcitys:[],
		provincecity:[],
		theindex:0
	}
  },
  created() {
  	this.$http.home.areas().then(res => {
  		this.citylist = res.data
  	})
  	this.$http.home.hotcitys().then(res => {
  		this.hotcitys = res.data
  	})
	this.$http.home.provincecity().then(res => {
		this.provincecity = res.data
	})
  },
  methods:{
	  tolaywer(cityid){
		  // this.$router.push('/findLawyers/lslist/'+cityid)
		  this.$router.push({name:'lslist',params:{cityid:cityid}});
	  },
	  provchange(e){
		  console.log(e)
		  this.theindex = e
	  },
	  citychange(e){
		  // this.$router.push('/findLawyers/lslist/'+e)
		  this.$router.push({name:'lslist',params:{cityid:e}});
	  }
  }
};
</script>

<style lang="scss" scoped>
.city {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .title24 {
    font-size: 24px;
    color: #101d37;
  }
  .domesticity {
    .domestitle {
      position: relative;
      padding-bottom: 15px;
      &::after {
        position: absolute;
        bottom: 0;
        left: 34px;
        content: "";
        width: 27px;
        height: 3px;
        background: linear-gradient(260deg, #3670e4 0%, #8eb4ff 100%);
      }
    }
    .domesearch {
      width: 796px;
      height: 66px;
      line-height: 66px;
      background: #ffffff;
      margin-top: 16px;
      border: 1px solid #dddddd;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      padding-left: 26px;
      padding-right: 10px;
      position: relative;
      .seaico {
        font-size: 18px;
        color: #999999;
        img {
          margin-right: 6px;
          width: 16px;
          margin-bottom: 4px;
        }
      }
      .seatext {
        padding-left: 10px;
        height: 100%;
        width: 620px;
        margin-right: 15px;
        border: none;
        outline: none;
        font-size: 18px;
        color: #999999;
      }
      .searchbtn {
        cursor: pointer;
        width: 100px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #0465ea;
        border: 1px solid #dddddd;
        border-radius: 5px;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
  .hotcity {
    font-size: 16px;
    color: #333333;
    .htit {
      margin-right: 30px;
    }
    span {
      cursor: pointer;
      margin-right: 20px;
       &:hover {
          color: #0465ea;
          
        }
    }
  }
  .selecity {
    .labelcity {
      font-size: 20px;
      color: #101d37;
      margin-right: 30px;
    }
    .select {
      .selc {
        width: 180px;
        margin-right: 20px;
      }
    }
  }
  .initselect {
    .inititle {
      font-size: 20px;
      color: #101d37;
    }
    .allist {
      margin-top: 25px;
      width: 100%;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 5px;
      .sitem {
        width: 100%;
        min-height: 56px;
        background: #f8f8f9;
        border-bottom: 1px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          background-color: #0465ea;
          .slabel {
            color: #fff;
            .labeicon {
              display: block;
            }
          }
        }
        .slabel {
          width: 56px;
          height: 100%;
          text-align: center;
          border-radius: 5px;
          position: relative;
          font-size: 24px;
          font-weight: 800;
          color: #afb3bb;
          .labeicon {
            display: none;
            color: #0465ea;
            font-size: 26px;
            position: absolute;
            right: -16px;
          }
        }
        .provincelist {
			display: flex;
			flex-wrap: wrap;
          flex: 1;
          padding: 20px 0;
          background-color: #fff;
          .provinceitem {
			  padding: 10px;
			  cursor: pointer;
            padding-left: 36px;
            // margin-bottom: 20px;
            .provincetitle {
              cursor: pointer;
              font-weight: bold;
              font-size: 18px;
              color: #333333;
              width: 80px;
              &:hover {
                color: #0465ea;
              }
            }
            .citylist {
              width: 960px;
            }
            .cityitem {
              cursor: pointer;
              margin-top: 3px;
              margin-bottom: 8px;
              margin-right: 18px;
              font-size: 14px;
              color: #333333;
              &:hover {
                color: #0465ea;
              }
            }
          }
        }
      }
    }
  }
}
</style>